(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CustomilyRmbgAPIService', customilyRmbgAPIService);

    function customilyRmbgAPIService() {
        const baseURL = `${process.env.VUE_APP_CUSTOMILY_REMOVE_BACKGROUND_API_URL}`;

        async function removeBG(image) {
            const formData = new FormData();
            formData.append('imagefile', image);

            try {
                const response = await fetch(baseURL, {
                    method: 'POST',
                    body: formData
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return await response.blob();
            } catch (error) {
                throw error;
            }
        }

        return {
            removeBG
        };
    }
})();
